import _ from "lodash"

import { HTTP_METHODS } from "./../../../../../constants"
import { makeExternalCall } from "./../../../../../helpers"
import { isRLTLang } from "../../../../../i18n"


const FETCH_OPTIONS_ENDPOINT = "/api/pa/options/list?list_number=21"

const formatOptions = (options) => options.map((option) => (
  { label: isRLTLang() ? option.valueAr : option.valueFr, value: option.rank }))


export const eventStatusUIHelper = (callback, keyword) => {

  let endpoint = FETCH_OPTIONS_ENDPOINT
  let query = {}
  if (!_.isEmpty(keyword)) {
    query = { q: keyword }
  }

  return new Promise((resolve, reject) =>
    makeExternalCall(HTTP_METHODS.GET, endpoint, {}, {}, query)
      .then(resp => {
        let result = {}
        if (_.isPlainObject(resp.data)) {
          result = [resp.data]
        } else {
          result = resp.data
        }
        resolve(callback(formatOptions(result)))
      })
      .catch(err => reject(err.response))
  )
}

export const EVENT_SERVICE_OFFER_BY_A_PARTNER = 3
export const EVENT_INFO_BY_A_THIRD_PARTY = 5
export const EVENT_TO_TEENAGER = 6


export const EVENT_STATUS = { 
  1: "EVENT.STATUS.STRUCTURE_TO_TEENAGER",
  2: "EVENT.STATUS.TEENAGER_TO_STRUCTURE",
  [EVENT_SERVICE_OFFER_BY_A_PARTNER]: "EVENT.STATUS.SERVICE_OFFER_BY_A_PARTNER" ,
  4: "EVENT.STATUS.INTERNAL",
  [EVENT_INFO_BY_A_THIRD_PARTY]: "EVENT.STATUS.INFO_BY_A_THIRD_PARTY",
  [EVENT_TO_TEENAGER]: "EVENT.STATUS.TO_TEENAGER",
}

/* export const eventStatusUIHelper = (intl) =>
  Object.keys(EVENT_STATUS).map((key) => ({
    value: parseInt(key),
    label: intl.formatMessage({ id: EVENT_STATUS[key] }),
  })) */
